import { Container } from "react-bootstrap"
import { Helmet } from "react-helmet-async";
import Footer from './Homepages/Footer';

const PrivacyPolicy = () => {
  return (
    <>
    <Helmet>
        <title>Privacy Policy | Techno Elevators Oman – Data Protection & Security</title>
        <meta name="description" content="Learn how Techno Elevators Oman handles your personal data. We are committed to secure, transparent, and responsible information practices across all services." />
        <meta name="keywords" content="techno elevators for villas,techno elevators for office buildings,commercial techno lift installation,high-rise techno elevators,techno elevator services in Muscat,elevator installation cost,home elevator installation near me,residential elevator installation,home elevator installers,lift installation services,elevator repair near me" />
        <link rel="canonical" href="https://www.techno-elevators.com/PrivacyPolicy" />
      </Helmet>
     <Container>
         <div className="prose max-w-none p-6">
        <h1>Privacy Policy</h1>

        <p>At Techno Elevators LLC, we respect your privacy and are committed to protecting your personal information. This policy explains how we collect, use, and safeguard your data.</p>

        <h2>1. Information Collection</h2>
        <p>We may collect personal information including names, email addresses, phone numbers, and project details when you contact us or request our services.</p>

        <h2>2. Use of Information</h2>
        <p>Collected information is used to provide services, respond to inquiries, manage projects, and improve our services. We may also use it for communication regarding updates, promotions, or announcements related to our services.</p>

        <h2>3. Data Protection</h2>
        <p>We implement appropriate technical and organizational measures to protect personal data from unauthorized access, disclosure, or misuse.</p>

        <h2>4. Sharing of Information</h2>
        <p>We do not sell or rent your personal information. We may share information with trusted partners such as Hyundai for service purposes, or as required by law.</p>

        <h2>5. Cookies and Tracking</h2>
        <p>Our website may use cookies or similar tracking technologies to enhance user experience. Users can manage cookie preferences through their browser settings.</p>

        <h2>6. Your Rights</h2>
        <p>You have the right to access, correct, or delete your personal information. For any requests regarding your data, please contact us at info@blackhawk-customs.com.</p>

        <h2>7. Changes to Policy</h2>
        <p>We may update this Privacy Policy periodically. Continued use of our website or services constitutes acceptance of the updated policy.</p>

        <h2>8. Contact</h2>
        <p>If you have any questions about this policy, please contact us at Techno Elevators LLC, info@blackhawk-customs.com, Oman.</p>
      </div>
     </Container>
      <Footer />
    </>
  )
}

export default PrivacyPolicy
